<script>
import SimpleTable from "@/view/order/extraFees/SimpleTable.vue";
import Quotation from "@/view/priceRule/incidentalCharge/Quotation.vue";

export default {
  name: "IncidentalCharge",
  components: {Quotation},
  data() {
    return {
      activeTab: 'waitCharge'
    }
  }
}
</script>

<template>
  <Card class="extra-fees-card">
    <Tabs :animated="false" v-model="activeTab" class="extra-fees-tabs">
      <TabPane name="waitCharge" label="未报价">
        <Quotation v-if="activeTab === 'waitCharge'" type="waitCharge" />
      </TabPane>
      <TabPane name="alreadyCharge" label="已报价">
        <Quotation v-if="activeTab === 'alreadyCharge'" type="alreadyCharge" />
      </TabPane>
    </Tabs>
  </Card>
</template>

<style scoped>
/* 表格高度由 SimpleTable 依据视口自行计算，这里仅去掉多余的间距 */
::v-deep .extra-fees-card .ivu-card-body {
  padding: 0;
}
</style>
